










































































































































































































































interface NavList {
    name: string;
    dataList: string;
}
import { Component, Vue, Prop } from "vue-property-decorator";
import ChooseSubjectVue from "../ChooseSubject.vue";
import { mapGetters } from "vuex";
import version from "@/version";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "choose-subject": ChooseSubjectVue
    }
})
export default class SubjectAssistBalance extends Vue {
    @Prop({ type: String })
    yearMonth?: string;

    @Prop({ type: String })
    startPeriod?: string;

    @Prop({ type: String })
    endPeriod?: string;

    subjectVal: Subject.Subject | null = null;
    tableData: Balance.Balance[] = [];

    // 选择科目
    valueList: any = {}; //select 的 model值
    assistOptions: Assist.AssistList | Object = {};
    allOption = {
        id: null,
        no: "",
        name: "全部"
    };
    // 选择assist
    changeAssist(str: string) {
        this.$forceUpdate();
        this.fetchData();
    }
    changeSubject(val: Subject.Subject) {
        this.subjectVal = val;
        this.$nextTick(() => {
            this.getAssistList();
            this.fetchData();

        })
    }

    // 获取辅助核算下拉列表
    async getAssistList() {
        if (this.subjectVal) {
            let names = this.subjectVal.dimAccountTypes;
            let i = 0;
            this.valueList = {};
            do {
                await this.getAssistData(names[i]);
                this.valueList[names[i]] = this.allOption;
                i++;
            } while (i < names.length);
            this.$forceUpdate();
        }
    }
    getAssistData(name: string) {
        return new Promise<void>(resolve => {
            Vue.axios
                .get(
                    `dim/find?accountBookId=${this.$store.state.accountBook.id
                    }&dimAccountType=${name}`
                )
                .then(res => {
                    // @ts-ignore
                    this.assistOptions[name] = res.data;
                    // @ts-ignore
                    this.assistOptions[name].unshift(this.allOption);
                    resolve();
                });
        });
    }

    // 获取select 的 model值
    getRelation() {
        if (this.subjectVal) {
            let obj: any = {
                subjectId: this.subjectVal.id
            };
            Object.keys(this.valueList).forEach(attr => {
                obj[this.transRelation(attr)] = this.valueList[attr].id;
            });

            return obj;
        }
    }

    transRelation(val: string) {
        switch (val) {
            case "项目":
                return "dimItemId";
            case "客户":
                return "dimCustomerId";
            case "部门":
                return "dimDepartmentId";
            case "员工":
                return "dimEmployeeId";
            case "存货":
                return "dimInventoryId";
            case "供应商":
                return "dimProviderId";
            case "dimItemId":
                return "项目";
            case "dimCustomerId":
                return "客户";
            case "dimDepartmentId":
                return "部门";
            case "dimEmployeeId":
                return "员工";
            case "dimInventoryId":
                return "存货";
            case "dimProviderId":
                return "供应商";
            default:
                return "dimItemId";
        }
    }

    // 获取表格数据
    fetchData() {
        if (this.subjectVal) {
            Vue.axios
                .post(`balances/find/dim`, {
                    accountBookId: this.$store.state.accountBook.id,
                    startPeriod: this.startPeriod,
                    endPeriod: this.endPeriod,
                    subjectId: this.subjectVal.id,
                    relation: this.getRelation()
                })
                .then(res => {
                    this.pageType = res.data.pageType;
                    this.tableData = res.data.balances;
                    this.refreshPageType();
                });
        }
    }
    // 选择 下拉框内容，页面切换
    subType: number | null = null;
    pageType: number | null = null;
    refreshPageType() {
        if (this.pageType == 1) {
            this.subType = 1;
        } else if (this.pageType == 2) {
            this.subType = 2;
        } else if (this.pageType == 3) {
            this.subType = 3;
        } else if (this.pageType == 4) {
            this.subType = 4;
        }
    }
    // 下载
    mainDownload() {
        if (this.subjectVal) {
            let url = `${Vue.axios.defaults.baseURL}export/balance/dim/subject?accountBookId=${this.$store.state.accountBook.id}&subjectId=${this.subjectVal.id}&startPeriod=${this.startPeriod}&endPeriod=${this.endPeriod}&version=${version}&token=${this.$store.state.account.token}`;
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", url);
        }
    }
    // 打印
    pageDownload() {
        if (this.subjectVal) {
            let url = `${Vue.axios.defaults.baseURL}export/pdf/balance/dim/subject?accountBookId=${this.$store.state.accountBook.id}&subjectId=${this.subjectVal.id}&startPeriod=${this.startPeriod}&endPeriod=${this.endPeriod}&version=${version}&token=${this.$store.state.account.token}`;
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", url);
        }
    }

    syncScroll() {
		const tbody = this.$el.querySelector(".data-table")!;
		this.$el.querySelectorAll(".col-fixed")!.forEach(td => {
            (<HTMLElement>td).style.transform = `translateX(${tbody.scrollLeft}px)`;
        });
    }
}
